import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'app-web-services',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule
  ],
  templateUrl: './web-services.component.html',
  styleUrl: './web-services.component.scss'
})
export class WebServicesComponent {

}
